import Price from '@/components/Price'
import FlashSalePrice from '@/components/Price/FlashSalePrice'
import PreOrder from '@/components/Price/PreOrder'
import type { FlashSaleModal, PreOrderType } from '@/types'

interface ProductPriceType {
  type?: string
  originPrice: number
  finalPrice: number
  priceAtWarehouse?: boolean
  flashSale: FlashSaleModal
  productId: string
  hasGift?: boolean
  isOutOfStock: boolean
  preOrder: PreOrderType
  preOrderPrice: number
}

export const ProductPrice = ({
  type = 'product-detail',
  originPrice,
  finalPrice,
  priceAtWarehouse,
  flashSale,
  productId,
  hasGift,
  isOutOfStock = false,
  preOrder,
  preOrderPrice,
}: ProductPriceType) => {
  if (preOrder) {
    return (
      <>
        {!isOutOfStock && (
          <div className='px-2.5 pb-1.5'>
            <PreOrder
              priceAtWarehouse={flashSale?.priceAtWarehouse}
              originPrice={originPrice}
              finalPrice={finalPrice}
              flashSale={flashSale}
              hasGift={hasGift}
              type={type}
              productId={productId}
              preOrder={preOrder}
              preOrderPrice={preOrderPrice}
            />
          </div>
        )}
      </>
    )
  } else {
    return (
      <>
        {!isOutOfStock && (
          <div className='entry-price mb-2 px-2'>
            {flashSale ? (
              <FlashSalePrice
                priceAtWarehouse={flashSale?.priceAtWarehouse}
                originPrice={originPrice}
                finalPrice={finalPrice}
                flashSale={flashSale}
                hasGift={hasGift}
                productId={productId}
              />
            ) : (
              <Price
                type={type}
                hasGift={hasGift}
                priceAtWarehouse={priceAtWarehouse}
                originPrice={originPrice}
                finalPrice={finalPrice}
              />
            )}
          </div>
        )}
      </>
    )
  }
}

export default ProductPrice
